import * as React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import { useColorScheme } from '@mui/material/styles';

import muLogo from '../logos/HKMU-logo.png';
import hksarLogo from '../logos/HKSAR-logo.png';
import sfuLogo from '../logos/SFU-logo.png';
import twcLogo from '../logos/TWC-logo.png';

const darkModeLogos = [
  hksarLogo,
  muLogo,
  sfuLogo,
  twcLogo
];

const lightModeLogos = [
  hksarLogo,
  muLogo,
  sfuLogo,
  twcLogo
];

const logoStyle = {
  'object-fit': 'contain',
  width: '100%'
};

export default function LogoCollection() {
  const { mode, systemMode } = useColorScheme();
  let logos;
  if (mode === 'system') {
    if (systemMode === 'light') {
      logos = lightModeLogos;
    } else {
      logos = darkModeLogos;
    }
  } else if (mode === 'light') {
    logos = lightModeLogos;
  } else {
    logos = darkModeLogos;
  }

  return (
    <Box id="logoCollection" sx={{ py: 4 }}>
      <Typography
        component="p"
        variant="subtitle2"
        align="center"
        sx={{ color: 'text.secondary' }}
      >
        Made in collaboration with
      </Typography>
      <Grid container sx={{ justifyContent: 'center', mt: 4, alignItems: 'center' }} spacing={8}>
        {logos.map((logo, index) => (
          <Grid key={index} sx={{width: '150px'}}>
            <img
              src={logo}
              alt={`Fake company number ${index + 1}`}
              style={logoStyle}
            />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}
